enum BillType {
  AVOIR = 'AVOIR',
  FACTURE = 'FACTURE',
}

export default BillType;
